import accordion from "./blocks/accordion/script";
document.addEventListener("DOMContentLoaded", function() {
    accordion()
});